import { render, staticRenderFns } from "./Observer.vue?vue&type=template&id=8506fa84&scoped=true&"
import script from "./Observer.vue?vue&type=script&lang=ts&"
export * from "./Observer.vue?vue&type=script&lang=ts&"
import style0 from "./Observer.vue?vue&type=style&index=0&id=8506fa84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8506fa84",
  null
  
)

export default component.exports